<template>
  <div class="page-main">
    <van-nav-bar
      title="系统设置"
      left-text="返回"
      left-arrow
      @click-left="$router.replace({name:'user'})"
    />      
    <div class="content">
      <div class="list">
        <van-cell-group >
          <van-cell title=账户管理 center size="large" is-link :to="{name:'account'}"></van-cell>
        </van-cell-group>                         
        <van-cell-group >
          <van-cell title=发布须知 center size="large" is-link :to="{name:'releaseNotes'}"></van-cell>
        </van-cell-group>                         
        <van-cell-group >
          <van-cell title=关于我们 center size="large" is-link @click="show=true"></van-cell>
        </van-cell-group>                         
      </div>
      <div class="footer">
        <van-button class="btn" @click="logout">退出登录</van-button>        
      </div>
    </div>   
    <van-popup v-model="show" get-container="body">
      <AboutUs @close="show=false"></AboutUs> 
    </van-popup>
  </div>
</template>

<script>
import AboutUs from '@/components/popUp/aboutUs'
export default {
  name: "setPage",
  components: { AboutUs },
  data() {
    return {
      show: false,
      memberInfo: this.$mdUtils.getUserInfo(),
    }
  },
  methods: {
    logout() {
      this.$mdUtils.logOff()
      this.$router.replace({ name: 'user' })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-main {
  background: $gray;
}
.footer {
  margin-top: 42px;
  text-align: center;
}
.btn {
  width: 300px;
  font-size: $font-size-big;
}
</style>
